import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const BalancedLivingIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        d="M22.7 15.9l-2.5-7.7h.7c.3 0 .6-.3.6-.6.1-.4-.2-.7-.6-.8h-5.7c-.3-1.2-1.4-2.1-2.7-2.1-1.3 0-2.4.9-2.7 2.1H4.1c-.3 0-.6.3-.6.6 0 .4.3.8.6.8h.7l-2.5 7.7h-1c-.1 2.3 1.6 4.3 3.9 4.4 2.3.1 4.3-1.6 4.4-3.9v-.5h-1L6.2 8.2h3.6c.3 1.2 1.4 2.1 2.7 2.1 1.3 0 2.4-.9 2.7-2.1h3.5l-2.5 7.7h-1c-.1 2.3 1.6 4.3 3.9 4.4 2.3.1 4.3-1.6 4.4-3.9v-.5h-.8zm-19 0l1.8-5.6 1.9 5.6H3.7zm8.8-7c-.6 0-1-.3-1.3-.8V8c-.1-.2-.1-.3-.1-.5s0-.3.1-.5v-.1c.2-.5.7-.8 1.3-.8s1 .3 1.3.8V7c.1.2.1.3.1.5s0 .3-.1.5v.1c-.3.5-.7.8-1.3.8zm5.1 7l1.9-5.6 1.8 5.6h-3.7z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </IconBase>
  );
};

export default BalancedLivingIcon;
